module.exports = __webpack_public_path__ + "img/list-next-arrow_b.0995ec68.svg";